import ElementComponent from '../../../Component/UI/Element';
import Game from '../../../Game';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import { GameActions } from '../../../State/Game/GameActions';
import { ContextType } from '../../../State/Game/IContext';
import { UserActions } from '../../../State/User/UserActions';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { StartAnimation } from '../../Animation/AnimationHelper';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import BaseUISystem from '../BaseUISystem';
import {
    applyBounceButtonAnimation,
    applyDefaultButtonAnimation,
} from '../UIHelper';
import BaseMenu from './BaseMenu';

const BTN_CLOSE: string = 'main_container/close_button';
const BTN_ADD: string = 'main_container/add_button';
const DECO_LEFT: string = 'main_container/deco_left';
const DECO_RIGHT: string = 'main_container/deco_right';

export default class CreateShortcutMenu extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('createShortcutMenu', uiSystem);

        this.resources.set(
            'createShortcutMenu',
            'resource/data/ui/createShortcutMenu.json'
        );

        this.resources.set(
            'atlas_create_shortcut_menu',
            'resource/graphics/export/atlas_ui_create_shortcut_menu.json'
        );
    }

    protected onShow(params?: any): void {
        // Left (box/coins) and right (box/fox) decoractions starts with scale equal to 0.
        const decoLeft = this.element.find(DECO_LEFT);
        const decoRight = this.element.find(DECO_RIGHT);

        const decoLeftElem: ElementComponent = decoLeft.getComponent(
            ElementComponent
        );
        const decoRightElem: ElementComponent = decoRight.getComponent(
            ElementComponent
        );

        decoLeftElem.scale.set(0, 0);
        decoRightElem.scale.set(0, 0);

        Game.sdk.gameTracking(FBTrackingEvent.CreateShortcutShow);
    }

    protected onShown(params?: any): void {
        // Scale up decorations.
        const decoLeft = this.element.find(DECO_LEFT);
        const decoRight = this.element.find(DECO_RIGHT);

        StartAnimation(decoLeft, 'BotOptInDecorationScaleUp');
        StartAnimation(decoRight, 'BotOptInDecorationScaleUp');
    }

    protected onCreate(): void {
        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            Game.sdk.gameTracking(FBTrackingEvent.CreateShortcutClose);
            this.system.state.dispatch(UserActions.dismissShortcut());
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        // Button subscribe.
        const btnAdd = this.element.find(BTN_ADD);
        btnAdd.on(GameObjectEvent.SELECTED, () => {
            Game.sdk.gameTracking(FBTrackingEvent.CreateShortcutAccept);
            Game.state.dispatch(
                GameActions.setContext(ContextType.CREATE_SHORTCUT)
            );
        });
        applyBounceButtonAnimation(btnAdd, AUDIO_UI_BUTTON_DEFAULT);
    }
}
